import {z} from "zod/v4-mini"
import * as legacyZod from "zod"
import {LegacyTextureType, TextureType} from "#material/types/texture"
import {mapEnumValueByKey} from "@cm/utils"

export type TextureResolution = "500px" | "1000px" | "2000px" | "original"
export const textureResolution = z.enum(["500px", "1000px", "2000px", "original"])
export const legacyTextureResolution = legacyZod.enum(["500px", "1000px", "2000px", "original"])

export const textureTypeSchema = z.enum(TextureType)

export const legacyTextureTypeSchema = z.enum([
    "Anisotropy",
    "AnisotropyRotation",
    "AnisotropyStrength",
    "Diffuse",
    "DiffuseRoughness",
    "Displacement",
    "Error",
    "F0",
    "IOR",
    "Mask",
    "Metalness",
    "Normal",
    "Roughness",
    "SpecularStrength",
    "SpecularTint",
    "Transmission",
])

export const textureTypeFromLegacy = (legacyTextureType: LegacyTextureType): TextureType => {
    return textureTypeSchema.parse(mapEnumValueByKey(legacyTextureType, LegacyTextureType, TextureType))
}
export const toLegacyTextureType = (textureType: TextureType): LegacyTextureType => {
    return legacyTextureTypeSchema.parse(mapEnumValueByKey(textureType, TextureType, LegacyTextureType)) as LegacyTextureType
}

export const textureTypeKeySchema = z.enum([
    "anisotropy",
    "anisotropyRotation",
    "anisotropyStrength",
    "diffuse",
    "diffuseRoughness",
    "displacement",
    "error",
    "f0",
    "ior",
    "mask",
    "metalness",
    "normal",
    "roughness",
    "specularStrength",
    "specularTint",
    "transmission",
])
export type TextureTypeKey = z.infer<typeof textureTypeKeySchema>

export const SET_TEXTURE_MAP_ASSIGNMENT_TEXTURE_TYPE_PARAMETER_KEY = "MapAssignment_TextureType"

export const mapAssignmentKeySchema = z.enum(["anisotropy", "diffuse", "displacement", "metalness", "normal", "roughness", "specularStrength"])
export type MapAssignmentKey = z.infer<typeof mapAssignmentKeySchema>

export const mapAssignmentSchema = z.strictObject({
    dataObjectId: z.string(),
    dataObjectLegacyId: z.number(),
    textureSetRevisionId: z.string(),
    textureSetRevisionLegacyId: z.number(),
})
export type MapAssignment = z.infer<typeof mapAssignmentSchema>
